package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.SliderDemo

@Page
@Composable
fun SliderPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/slider.md", mapOf("title" to listOf("Slider"), "description" to listOf("An input where the user selects a value from within a given range."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/slider"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/slider#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import radix_ui.components.SliderProps
import react.FC
import shadcn.ui.components.Slider

val SliderDemo = FC<SliderProps> {
    Slider {
        defaultValue = arrayOf(50)
        max = 100
        step = 1
        className = it.className
    }
}"""){ 
 SliderDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Slider
""", lang= "kotlin", highlight= "")
            CodeBlock("""Slider {
    defaultValue = arrayOf(33)
    max = 100
    step = 1
}
""", lang= "kotlin", highlight= "")
        }
    }
}
